import React from 'react';
import './styles.css';
import { useTranslation } from 'react-i18next';

const CardSection = () => {
  const { t } = useTranslation();
  return (
    <section className="cards-container">
      <article className="card card--mission">
        <h3 className="card-title">{t('home.our_mission')}</h3>
        <div className="card-overlay">
          <h3>{t('home.our_mission')}</h3>
          <p>{t('home.our_mission_text')}</p>
        </div>
      </article>

      <article className="card card--essence">
        <h3 className="card-title">{t('home.our_essence')}</h3>
        <div className="card-overlay">
          <h3>{t('home.our_essence')}</h3>
          <p>{t('home.our_essence_text')}</p>
        </div>
      </article>

      <article className="card card--commitment">
        <h3 className="card-title">{t('home.our_commitment')}</h3>
        <div className="card-overlay">
          <h3>{t('home.our_commitment')}</h3>
          <p>{t('home.our_commitment_text')}</p>
        </div>
      </article>

      <article className="card card--value">
        <h3 className="card-title">{t('home.value_proposition')}</h3>
        <div className="card-overlay">
          <h3>{t('home.value_proposition')}</h3>
          <p>{t('home.value_proposition_text')}</p>
        </div>
      </article>
    </section>
  );
};

export default CardSection;
